import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import "./Nos_Secteur.css";
import { useTranslation } from 'react-i18next';

const Nos_Secteur = () => {
  const { t } = useTranslation();
  
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <motion.div
      id="container_NS"
      variants={containerVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      ref={ref}
    >
      <div id="toggleContainer">
        <div className="secteur-title">
          <span className="sub-title">{t('Nos Secteurs')}</span>
          <h2>{t('Secteur d`intervention:')}</h2>
          <p>
            {t(
              'La société « PROFESSIONAL INSPECTORS » se distingue par son expertise étendue dans divers secteurs, notamment le Pétrole et gaz, l`Énergie, les Mines, la Construction métallique, l`Industrie et les Services. Forte de son engagement envers l`excellence, elle s`impose comme un acteur incontournable, offrant des services spécialisés et une approche professionnelle de haut niveau pour répondre aux besoins variés de ses clients.'
            )}
          </p>
        </div>
      </div>
      <motion.div
        className="Bposition"
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 1 }}
      >
        <a className="button2" href="/secteurs">{t('Plus de détails')}</a>
      </motion.div>
    </motion.div>
  );
};

export default Nos_Secteur;
